import type { CasaLeonOperationalEvent, CasaLeonWorldSnapshot } from '@casa-leon-vivo/contracts/casa-leon';
import { applyOperationalEvent, emptyCasaLeonSnapshot, rebuildFromEvents } from './world-reducer.js';

/** Sesi�n operativa simulada � estado gobierna la vista (Orden 014). */
export class MundoVivoSession {
  private snapshot: CasaLeonWorldSnapshot = emptyCasaLeonSnapshot();

  getSnapshot(): CasaLeonWorldSnapshot {
    return this.snapshot;
  }

  apply(event: CasaLeonOperationalEvent): CasaLeonWorldSnapshot {
    this.snapshot = applyOperationalEvent(this.snapshot, event);
    return this.snapshot;
  }

  applyMany(events: CasaLeonOperationalEvent[]): CasaLeonWorldSnapshot {
    for (const event of events) {
      this.snapshot = applyOperationalEvent(this.snapshot, event);
    }
    return this.snapshot;
  }

  reset(): CasaLeonWorldSnapshot {
    this.snapshot = emptyCasaLeonSnapshot();
    return this.snapshot;
  }

  rebuild(events: CasaLeonOperationalEvent[]): CasaLeonWorldSnapshot {
    this.snapshot = rebuildFromEvents(events);
    return this.snapshot;
  }
}
